import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';

@Directive({
    selector: '[shChildIndex]',
    standalone: true
})
/**
 * Directive that sets saves index of each child element on the html element itself.
 * Use in combination with the ArrowNavigation helper to set the index of each child element.
 * Set this on the options container.
 */
export class ShChildIndexDirective implements OnInit, OnDestroy {
    private observer: MutationObserver;

    @Input() OPTION_QUERY: string = ':not(.-sh-disabled)';

    constructor(private el: ElementRef<HTMLElement>) {}

    ngOnInit(): void {
        this.updateChildIndices();

        this.observer = new MutationObserver(() => {
            this.updateChildIndices();
        });

        this.observer.observe(this.el.nativeElement, {
            childList: true,
            subtree: false
        });
    }

    ngOnDestroy(): void {
        this.observer?.disconnect();
    }

    private updateChildIndices(): void {
        const children = Array.from(this.el.nativeElement.children);
        this.el.nativeElement.dataset.childCount = String(children.length);

        let disabledCount: number = 0;
        for (let index = 0; index < children.length; index++) {
            const child: HTMLElement = children[index] as HTMLElement;
            if (!this.shouldCountElement(child)) {
                disabledCount++;
                continue;
            }
            child.dataset.index = String(index - disabledCount);
        }
    }

    private shouldCountElement(el: HTMLElement): boolean {
        return el.matches(this.OPTION_QUERY);
    }
}
